export const getEnrichmentPayload = (
  searchType: string,
  text: string,
  customParams?: any,
  geneFilterType: 'symbol' | 'ensemblId' | 'geneId' | 'uniprotId' = 'symbol'
) => {
  const lines = String(text || '')
    .split('\n')
    .map(l => l.trim())
    .filter(Boolean);

  const defaultParams = {
    commonVariants: 2,
    commonGenes: 2,
    maxPvalue: 0.1,
    maxScore: 1,
    minScore: 0.1,
    pageNumber: 0,
    source: 'ALL',
  };

  const params = { ...defaultParams, ...(customParams || {}) };

  if (searchType === 'GENES') {
    const payload = {
      commonGenes: params.commonGenes ?? params.commonVariants ?? 2,
      geneENSEMBLList: '',
      geneNCBIList: '',
      geneHGNCList: '',
      geneUniProtList: '',
      maxPvalue: params.maxPvalue,
      maxScore: params.maxScore,
      minScore: params.minScore,
      pageNumber: params.pageNumber,
      source: params.source,
    };

    const joined = lines.join(',');

    if (geneFilterType === 'symbol') {
      payload.geneHGNCList = joined;
    } else if (geneFilterType === 'ensemblId') {
      payload.geneENSEMBLList = joined;
    } else if (geneFilterType === 'geneId') {
      payload.geneNCBIList = joined;
    } else if (geneFilterType === 'uniprotId') {
      payload.geneUniProtList = joined;
    }

    return payload;
  }

  if (searchType === 'VARIANTS') {
    return {
      commonVariants: params.commonVariants ?? 2,
      variantList: lines.join(','),
      maxPvalue: params.maxPvalue,
      maxScore: params.maxScore,
      minScore: params.minScore,
      pageNumber: params.pageNumber,
      source: params.source,
    };
  }

  return params;
};

export function createEnrichmentInfoContent({
  searchType,
  text,
  enrichmentParams,
  geneFilterType,
}) {
  return `ENRICHMENT INFORMATION
========================

Download Date:   ${new Date().toLocaleString()}

QUERY
-----
Search Type:     ${searchType}
Query Text:      ${text}

PARAMETERS
----------
Filter Type:     ${searchType === 'GENES' ? geneFilterType.replace('geneSymbol', 'symbol') : 'strID'}
Custom Params:   ${JSON.stringify(enrichmentParams, null, 2)}

========================`;
}



